import React, { useState } from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";
import "./Admission_Process.css";

export default function Admission_Process() {
  const [modalshow, setmodalshow] = useState(false);

  const openModal = () => {
    setmodalshow(true);
  };

  return (
    <section className="AdmissionProcess py-5">
      <div className="container">
        {/* Heading */}
        <div className="row">
          <div className="col-lg-12">
            <h2 className="text-center text-white">
              <b>Admission Process</b>
            </h2>
          </div>
        </div>

        {/* Steps */}
        <div className="row mt-3">
          {/* Step 01 */}
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="step-box1">
              <div className="step-circle1">
                Step
                <br />
                <h2 className="text-white fs-2">
                  <strong>01</strong>
                </h2>
              </div>

              <ul className="step-list">
                <li><FontAwesomeIcon icon={faCheck} /> Learner's Authentication</li>

                <li>
                  <FontAwesomeIcon icon={faCheck} />{" "}
                  Visit{" "}
                  <span className="link-text" onClick={openModal}>
                    DPU Login Page
                  </span>
                </li>

                <li><FontAwesomeIcon icon={faCheck} /> Fill in your details</li>
                <li><FontAwesomeIcon icon={faCheck} /> Enter DEB Unique ID</li>
                <li><FontAwesomeIcon icon={faCheck} /> Mobile verification</li>
                <li><FontAwesomeIcon icon={faCheck} /> Email verification</li>
                <li><FontAwesomeIcon icon={faCheck} /> Upload e-Aadhar</li>
              </ul>
            </div>
          </div>

          {/* Step 02 */}
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="step-box1">
              <div className="step-circle1">
                Step
                <br />
                <h2 className="text-white fs-2">
                  <strong>02</strong>
                </h2>
              </div>

              <ul className="step-list">
                <li><FontAwesomeIcon icon={faCheck} /> Admission Form</li>
                <li><FontAwesomeIcon icon={faCheck} /> Fill personal details</li>
                <li><FontAwesomeIcon icon={faCheck} /> Educational & employment details</li>
                <li><FontAwesomeIcon icon={faCheck} /> Upload photo & signature</li>
                <li><FontAwesomeIcon icon={faCheck} /> Online fee payment</li>
                <li><FontAwesomeIcon icon={faCheck} /> Submit form</li>
              </ul>
            </div>
          </div>

          {/* Step 03 */}
          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="step-box1">
              <div className="step-circle1">
                Step
                <br />
                <h2 className="text-white fs-2">
                  <strong>03</strong>
                </h2>
              </div>

              <ul className="step-list">
                <li><FontAwesomeIcon icon={faCheck} /> Admission Confirmation</li>
                <li><FontAwesomeIcon icon={faCheck} /> Document verification</li>
                <li><FontAwesomeIcon icon={faCheck} /> Fee receipts</li>
                <li><FontAwesomeIcon icon={faCheck} /> Confirmation Email</li>
                <li><FontAwesomeIcon icon={faCheck} /> SMS login credentials</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Documents Section */}
        <div className="row mt-4">
          {/* Required Docs */}
          <div className="col-lg-4 col-md-6 col-sm-6">
            <h3 className="text-white doc_title">Documents Required</h3>

            <ul className="list-unstyled text-white doc_list">
              <li><FontAwesomeIcon icon={faCheck} /> Govt ID (Aadhaar/Passport)</li>
              <li><FontAwesomeIcon icon={faCheck} /> Passport-size photo</li>
              <li><FontAwesomeIcon icon={faCheck} /> Signature</li>
              <li><FontAwesomeIcon icon={faCheck} /> Marriage Certificate (if applicable)</li>
              <li><FontAwesomeIcon icon={faCheck} /> Gazette (Name change)</li>
            </ul>
          </div>

          {/* Format */}
          <div className="col-lg-4 col-md-6 col-sm-6">
            <h3 className="text-white doc_title">Document Format</h3>

            <ul className="list-unstyled text-white doc_list">
              <li><FontAwesomeIcon icon={faCheck} /> JPEG/JPG/PNG</li>
              <li><FontAwesomeIcon icon={faCheck} /> 320 × 240px</li>
              <li><FontAwesomeIcon icon={faCheck} /> Photo & Sign &lt; 600KB</li>
              <li><FontAwesomeIcon icon={faCheck} /> Docs up to 1MB</li>
            </ul>
          </div>

          {/* Contact Box */}
          <div className="col-lg-4">
            <div className="adm-box">
              <p>
                For admission-related queries, feel free to contact us:
              </p>

              <span className="link-text" onClick={openModal}>
                <strong>info@profcyma.com</strong>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
}